var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTranslation24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Translation24x24",
    transform: "translate(-2 -3)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M14.6,15.2h2.216l-1.064-3.1Z",
    transform: "translate(-1.236 -1.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M2,3V19H20V3Zm3.78,9.422a26.8,26.8,0,0,0,2.61-1.778,7.442,7.442,0,0,1-1.8-2.578H7.67a7.6,7.6,0,0,0,1.35,1.956,3.363,3.363,0,0,0,1.35-2.578H4.97V6.2H8.3V5.311H9.56v.978h3.15V7.356H11.63a5.73,5.73,0,0,1-1.62,3.289,7.539,7.539,0,0,0,2.61,1.778l-.45.978a9.41,9.41,0,0,1-3.06-1.956,29.6,29.6,0,0,1-2.79,1.778Zm10.8,4.711L15.86,15H13.07l-.81,2.133h0a2.712,2.712,0,0,1-2.97-.978l-.45.178-.18-1.778,1.98.8-.45.267a2.983,2.983,0,0,0,1.26,1.067l2.52-6.578h1.08l2.61,7.022Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTranslation24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_Translation24x24.c6946a2c56d2f9c9dda256dd4f6edd25.svg";